import { Button } from "reactstrap";
import React, { useState } from "react"
import { Col } from "reactstrap"
import '../contracts/invoices/InvoiceDetailsComp.css'
import logo from "../../../assets/images/QN-logo-mini.png"
import { useParams } from "react-router-dom";
import { formatCurrency } from "../../../utils/formatCurrency";
import { useGetInstence } from "../../../hooks/useGetInstence";
import { getPayslipe } from "../../../api/payslipes";
import moment from "moment";
import PrintPayslipModal from "./PrintPayslipModal";

export default function PayslipeDetails({}){  
  const {id: payslipeId} = useParams()
  const [payslipe, setPayslipe] = useState(null);
  
  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getPayslipe,
    payslipeId,
    (response) => {
      setPayslipe({
        ...response.data.data.payslipe,
      });
    }
  );

  // Print
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);

  return(
      <div className="page-content payslip-details">
        <div className="container">
          {!instenceLoading && payslipe && <>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 style={{fontWeight: "bold", fontSize: "25px"}}>#{payslipe.id}</h5>
                <h5>{payslipe.employee.name}</h5>
                <h5>{payslipe.employee.street} {payslipe.employee.house_number}</h5>
                <h5>{payslipe.employee.zip_code} {payslipe.employee.country?.name}</h5>
                <h5>{payslipe.employee.city}</h5>
              </div>
              <div style={{textAlign: "right"}}>
                <img src={logo} alt="" style={{width: "120px"}} />
              </div>
            </div>

            <h4 className="mt-3 mb-4" style={{fontWeight: "bold", textAlign: "center"}}>Payment Specification</h4>
            
            <div>
                <div className="separator mb-4"></div>

                {payslipe.hours.filter(h => h.hoursLength > 0).length > 0 && <>
                  {payslipe.hours.filter(h => h.hoursLength > 0).map(h => <div key={h.id} style={{marginBottom:"30px"}}>
                      <h4 className="mb-3">{h.collection.pool.name}</h4>

                      <div className="invoiceable head">
                        <span className="date">Date</span>
                        <span className="date">Start</span>
                        <span className="date">End</span>
                        <span className="date">Break</span>
                        <span className="date">Length</span>
                        <span className="price">Price</span>
                      </div>

                      {h?.periods.filter(p => p.length > 0).map(p => <div key={p.id} className="invoiceable">
                        <span className="date">{moment(p.from).format("DD MMM YYYY")}</span>
                        <span className="date">{moment(p.from).format("hh:mm A")}</span>
                        <span className="date">{moment(p.to).format("hh:mm A")}</span>
                        <span className="date">{p.breakHours}</span>
                        <span className="date">{p.length}</span>
                        <span className="price">{formatCurrency(h.hourPrice * p.length)}</span>
                      </div>)}

                      <div className="invoiceable head mt-2">
                        <span>Total</span>
                        <span>{formatCurrency(h.periods.reduce((total, p) => h.hourPrice * p.length + total, 0))}</span>
                      </div>

                      <div className="separator mb-4 mt-4"></div>
                    </div>)}
                  </>}

                <div className="invoiceable head" style={{fontSize: '18px'}}>
                    <span>Total</span>
                    <span>
                      {formatCurrency(payslipe?.hours?.reduce((acc, h) => 
                        acc + h.hoursLength * h.hourPrice, 0)
                      )}
                    </span>
                  </div>
            </div>

            <div className="separator mb-4 mt-4"></div>

            {payslipe.employee?.priceComponents?.filter(com => com?.lastPaidDate)?.length > 0 && <>
                {payslipe.employee?.priceComponents?.filter(com => com?.lastPaidDate)?.map(item => 
                  <div key={item.id} style={{textAlign: "left", fontSize: "18px"}}>
                    <span>{item.priceComponent.name}: </span>
                    <span>{moment(item.lastPaidDate).format("DD MMM YYYY")}</span>
                  </div>
                )}
              </>
            }

            {payslipe.priceComponents.filter(com => com?.PayslipePriceComponents.value != 0)?.length > 0 && <>
                {payslipe.priceComponents.filter(com => com?.PayslipePriceComponents.value != 0)?.map(item => 
                  <div key={item.id} style={{textAlign: "right", fontSize: "18px"}}>
                    <span>{item.priceComponent.name}: </span>
                    <span>{formatCurrency(item?.PayslipePriceComponents.value)}</span>
                  </div>
                )}
                <div className="separator mb-4 mt-4"></div>
              </>
            }

            {payslipe.deductions.length > 0 && <> {payslipe.deductions.map(c => {
              return <div key={c.id} style={{textAlign: "right", fontSize: "18px"}}>
                  <span>{c.description || 'Deductions'}: </span>
                  <span>{formatCurrency(c.amount)}</span>
              </div>
            })}
            <div className="separator mb-4 mt-4"></div>
            </>}

            {payslipe.fines.length > 0 &&  <div style={{textAlign: "right", fontSize: "18px"}}>
              <span>Fines: </span>
              <span>{formatCurrency(payslipe.fines.reduce((acc, c) => acc + c.administration_cost + c.cost, 0))}</span>
              <div className="separator mb-4 mt-4"></div>
            </div>}

            {payslipe.privateUses.length > 0 &&  <div style={{textAlign: "right", fontSize: "18px"}}>
                <span>Private Use: </span>
                <span>{formatCurrency(payslipe.privateUses.reduce((acc, c) => acc + c.cost, 0))}</span>
                <div className="separator mb-4 mt-4"></div>
            </div>}

            <div style={{textAlign: "right", fontSize: "21px", fontWeight: "bold"}}>
                <span>Total: </span>
                <span>{formatCurrency(payslipe.price)}</span>
            </div>

            <Col className="mb-5 mt-3 print" md={12}>
              <Button size="lg" color="primary" onClick={() => setIsPrintModalOpen(true)}>
                Print
              </Button>
            </Col>

            <PrintPayslipModal
              isOpen={isPrintModalOpen}
              handleClose={() => setIsPrintModalOpen(false)}  
              payslip={payslipe}
            />
            
          </>}
        </div>
      </div>
    )
}